import { render, staticRenderFns } from "./TOSRefused.vue?vue&type=template&id=9f75dd28&scoped=true&"
import script from "./TOSRefused.vue?vue&type=script&lang=ts&"
export * from "./TOSRefused.vue?vue&type=script&lang=ts&"
import style0 from "./TOSRefused.vue?vue&type=style&index=0&id=9f75dd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f75dd28",
  null
  
)

export default component.exports